import React from "react"
import { graphql, useStaticQuery } from "gatsby"

const AvocatContentJeanPaul = ({ className }) => {
  const { allWordpressPage } = useStaticQuery(
    graphql`
      query {
        allWordpressPage(
          filter: { title: { eq: "jean-paul" } }
        ) {
          edges {
            node {
              id
              title
              content
            }
          }
        }
      }
    `
  )
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: allWordpressPage.edges[0]?.node.content,
      }}
    />
  )
}

export default AvocatContentJeanPaul
